import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Layout from "./components/Layout";
import My from "./pages/My";
import ChatInfo from "./pages/Party/ChatInfo";
import MatchingInfo from "./pages/Party/MatchingInfo";
import PartyInfo from "./pages/Party/PartyInfo";
import PartyInfo_Youtube_World from "./pages/Party/PartyInfo_Youtube_World";
import BlackList from "./pages/Users/BlackList";
import Comment from "./pages/Users/Comment";
import ExitUserInfo from "./pages/Users/ExitUserInfo";
import UserInfo from "./pages/Users/UserInfo";
import UserDetail from "./pages/Users/UserDetail";
import PartyDetail from "./pages/Party/PartyDetail";
import CouponManage from "./pages/Benefit/CouponManage";
import PointManage from "./pages/Benefit/PointManage";
import Login from "./pages/Login";
import UserLog from "./pages/UserLog/UserLog";
import AlimTalk from "./pages/Message/AlimTalk";
import ManageAuth from "./pages/Manage/ManageAuth";
import ManageLog from "./pages/Manage/ManageLog";
import PayInfo from "./pages/Pay/PayInfo";
import ReservedPay from "./pages/Pay/ReservedPay";
import PayFail from "./pages/Pay/PayFail";
import LMS from "./pages/Message/LMS";
import DashBoard from "./pages/Dashboard/DashBoard";
import AlimTalkFail from "./pages/Message/AlimTalkFail";
import SunsetDetail from "./pages/Manage/Sunset/SunsetDetail";
import Sunset from "./pages/Manage/Sunset/Sunset";
import PartyInvite from "./pages/Party/PartyInvite";
import ManageFaq from "./pages/Manage/ManageFaq/ManageFaq";
import ManageFaqDetail from "./pages/Manage/ManageFaq/ManageFaqDetail";
import Popup from "./pages/Manage/Popup";
import ManageTempAccount from "./pages/Manage/ManageTempAccount";
import Notice from "./pages/LinkidManage/Notice/Notice";
import UplusMatchingInfo from "./pages/Party/UplusMatchingInfo";
import Home from "./pages/Home";
import DefaultModalLayout from "./components/Modal/DefaultModalLayout";
import ManageValidCheck from "./pages/Manage/ManageValidCheck";
import Status from "./pages/Manage/Status";
import NewUserLog from "./pages/NewUserLog/NewUserLog";
import OldUplusMatchingInfo from "./pages/Party/OldUplusMatchingInfo";
import UplusInfo from "./pages/Party/UplusInfo";
import MatchMakingPartyInfo from "./pages/Party/MatchMakingPartyInfo";
import N_MatchMakingPartyInfo from "./pages/Party/N_MatchMakingPartyInfo";

import StampManage from "./pages/Benefit/StampManage";
import Suggest from "./pages/LinkidManage/Suggest/Suggest";
import PartyExitReason from "./pages/LinkidManage/PartyExitReason/PartyExitReason";
import Lingokids from "./pages/Party/Lingokids";
import Prereg_linkai from "./pages/Benefit/Prereg_linkai";
import YoutubeInfo from "./pages/Party/YoutubeInfo";
import AppPush from "./pages/Message/AppPush";

type LocationProps = {
  state: {
    background: Location;
  };
};

export default function Routers() {
  const location = useLocation() as LocationProps;
  const background = location?.state && location?.state?.background;
  const navigate = useNavigate();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        {/* {background && (
          <Route
            path="modal"
            element={
              <DefaultModalLayout
                modalTitle="모달 테스트"
                closeEvent={() => navigate("/")}
                confirmEvent={() => navigate("/")}
              >
                <>모달 테스트</>
              </DefaultModalLayout>
            }
          />
        )} */}

        <Route path="my" element={<My />} />
        {/* 대시보드 */}
        <Route path="dashboard" element={<DashBoard />} />
        {/* 회원 관리 */}
        <Route path="users/info" element={<UserInfo />} />
        <Route path="users/info/:userId" element={<UserDetail />} />
        <Route path="users/comment" element={<Comment />} />
        <Route path="users/black-list" element={<BlackList />} />
        <Route path="users/exit-users-info" element={<ExitUserInfo />} />
        {/* 파티 관리 */}
        <Route path="party/info/" element={<PartyInfo />} />
        <Route path="party/info/:partyId" element={<PartyDetail />} />
        <Route path="party/matching" element={<MatchingInfo />} />
        <Route path="party/chat" element={<ChatInfo />} />
        <Route path="party/invite" element={<PartyInvite />} />
        <Route path="party/uplus" element={<UplusInfo />} />
        <Route path="party/old-uplus" element={<OldUplusMatchingInfo />} />
        <Route path="party/match-making" element={<MatchMakingPartyInfo />} />
        <Route
          path="party/N_match-making"
          element={<N_MatchMakingPartyInfo />}
        />
        <Route path="party/lingokids" element={<Lingokids />} />

        <Route path="party/youtube" element={<YoutubeInfo />} />

        <Route path="party/youtube_world" element={<PartyInfo_Youtube_World />} />

        {/* 유저 로그 */}
        <Route path="userlog" element={<UserLog />} />
        <Route path="new-userlog" element={<NewUserLog />} />
        {/* 정산 관리 */}
        <Route path="pay/info" element={<PayInfo />} />
        <Route path="pay/reserve" element={<ReservedPay />} />
        <Route path="pay/fail" element={<PayFail />} />
        {/* 혜택 관리 */}
        <Route path="benefit/coupon" element={<CouponManage />} />
        <Route path="benefit/point" element={<PointManage />} />
        <Route path="benefit/stamp" element={<StampManage />} />
        <Route path="benefit/prereg_linkai" element={<Prereg_linkai />} />

        {/* 메세지 관리 */}
        <Route path="message/alimtalk" element={<AlimTalk />} />
        <Route path="message/lms" element={<LMS />} />
        <Route path="message/alimtalk/fail" element={<AlimTalkFail />} />
        <Route path="message/app-push" element={<AppPush />} />
        {/* 링키드 관리 */}
        <Route
          path="linkid-manage/valid-check"
          element={<ManageValidCheck />}
        />
        <Route
          path="linkid-manage/temp-account"
          element={<ManageTempAccount />}
        />
        <Route path="linkid-manage/sunset" element={<Sunset />} />
        <Route
          path="linkid-manage/sunset/:sunsetId"
          element={<SunsetDetail />}
        />
        <Route path="linkid-manage/sunset/setting" element={<SunsetDetail />} />
        <Route path="linkid-manage/faq" element={<ManageFaq />} />
        <Route path="linkid-manage/faq/:faqId" element={<ManageFaqDetail />} />
        <Route path="linkid-manage/popup" element={<Popup />} />
        <Route path="linkid-manage/status" element={<Status />} />
        <Route path="linkid-manage/notice" element={<Notice />} />
        <Route
          path="linkid-manage/notice/:noticeId"
          element={<ManageFaqDetail />}
        />
        <Route path="linkid-manage/terms" element={<Notice />} />
        <Route
          path="linkid-manage/terms/:termsId"
          element={<ManageFaqDetail />}
        />
        <Route path="linkid-manage/suggest" element={<Suggest />} />
        <Route
          path="linkid-manage/party-exit-reason"
          element={<PartyExitReason />}
        />

        {/* 관리자 */}
        <Route path="manage/auth" element={<ManageAuth />} />
        <Route path="manage/log" element={<ManageLog />} />
      </Route>
    </Routes>
  );
}
